import qs from "qs";
var data = qs.stringify({
  grant_type: "password",
  // Todoto: Update username and password to run ",
  username: "",
  password: "",
  scope: "openid profile",
});
export const localConfig = {
  method: "post",
  url: "https://abs-qa1.oktapreview.com/oauth2/ausdvuyculRIYitXg0h7/v1/token",
  headers: {
    Accept: "application/json",
    Content: "application/json",
    "Content-Type": "application/x-www-form-urlencoded",
    Authorization:
      "Basic MG9hZm44Yzh5cmxFamxzdUEwaDc6SE1Va2NZYlhadkFjbDlkVVBkY2FfQW5wS1FFVW5CTmRkc2VfLTdNbw==",
    Cookie:
      "incap_ses_512_1939383=D8UtekBSTAyK3Kc/3P0aB/fN9mEAAAAA3F3hpK8DMsy46mtS5R4MiQ==; nlbi_1939383=sawLHHpQWn6hYUIDWNi3vQAAAAAmIaYtjaJ7ubNNIemm0/x1; visid_incap_1738022=/BfrtjYxTI6jAtBCTIcYEPpHZGEAAAAAQkIPAAAAAADy0NbK3ZcQXzqg7rdT7E6j; visid_incap_1939383=iRW0WfOfRJebOPwQcKZCquCq1WEAAAAAQUIPAAAAAAB5n3v6KKDyvg5zizyLHqWS; JSESSIONID=20675699DB0E9D6E681323B695F89949",
  },
  data: data,
};
